import React from "react";
import { Link } from "react-router-dom";

/**
 * Campus tile for report flows — matches ManageClusters campus styling (no edit/delete).
 */
const ReportCampusCard = ({ to, name }) => (
  <Link to={to} className="block h-full outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 rounded-xl">
    <div className="relative flex h-full min-h-[120px] cursor-pointer flex-col items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-md transition-all duration-300 hover:bg-gradient-to-br hover:from-white hover:to-blue-50">
      <h5 className="text-center text-xl font-semibold text-gray-800">{name}</h5>
      <div
        className="absolute bottom-0 left-0 h-[5px] w-full rounded-b-xl bg-gradient-to-r from-sky-700 via-sky-400 to-sky-200"
        aria-hidden
      />
    </div>
  </Link>
);

export default ReportCampusCard;
